import { Card } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { char } from "../../utils";

export const Error404 = () => {
  let navigate = useNavigate();
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-12"></div>
          <div className="col-md-4 col-sm-12 position-absolute top-50 start-50 translate-middle">
            <Card bordered={false}>
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-12 text-center">
                      <img
                        width={150}
                        className="mb-2"
                        src="assets/images/logo/logo.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="row">
                    <p className="text-center h3 fw-bold mt-3">
                      ARDHI UNIVERSITY
                    </p>
                    <p className="text-center h4 fw-bold mt-3">
                      {char.toLowerCase("ARDHI IDENTITY CARD PORTAL")}
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <hr />
                      <div className="row">
                        <div className="col-12 text-center">
                          <img
                            width={200}
                            className="mb-2"
                            src="assets/images/logo/404.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-12 text-center">
                          <button
                            className="btn btn-soft-danger"
                            onClick={() => {
                              navigate(-1);
                            }}
                          >
                            Back to Previous
                          </button>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-5">
                        <div className="col-12 text-center">
                          <p className="mb-0">
                            © {new Date().getFullYear()} &nbsp;{" "}
                            <span className="fw-bold h6 text-primary">aru</span>
                          </p>
                          <p className="fw-light h6 text-warning fs-11 fst-italic mt-2">
                            {" "}
                            ---- weledi na ustawi ----
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-md-4 col-sm-12"></div>
        </div>
      </div>
    </>
  );
};
